export enum EnvironmentConfigurationEnum {
  Dev = 'dev',
  Test = 'testing',
  Staging = 'staging',
  Prod = 'production',
}
